import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-system-status-dashboard",
	templateUrl: "./system-status-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SystemStatusDashboardComponent implements OnInit {
	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenue.subscribe((venue) => {});
	}
}
